import { render, staticRenderFns } from "./Highcharts.vue?vue&type=template&id=2bf898f9&"
import script from "./Highcharts.vue?vue&type=script&lang=js&"
export * from "./Highcharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports